import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faChevronRight } from '@fortawesome/free-solid-svg-icons';

function isChangePasswordTabActive(pathname) {
  return (
    pathname === '/super-admin/settings' ||
    pathname.startsWith('/super-admin/settings/password')
  );
}

export default function SuperAdminSettingsLayout() {
  const location = useLocation();
  const { pathname } = location;
  const active = isChangePasswordTabActive(pathname);

  return (
    <div className="family-tree-container settings-shell settings-shell--with-inner-nav">
      <nav className="left-side settings-inner-nav-aside" aria-label="Settings sections">
        <ul>
          <li className={active ? 'active' : ''}>
            <Link to="/super-admin/settings/password" className="settings-inner-nav-link">
              <span className="settings-inner-nav-link-main">
                <FontAwesomeIcon icon={faLock} className="settings-inner-nav-icon" aria-hidden />
                <span className="settings-inner-nav-text">Change Password</span>
              </span>
              <span className="drop-icon" aria-hidden>
                <FontAwesomeIcon icon={faChevronRight} />
              </span>
            </Link>
          </li>
        </ul>
      </nav>
      <div className="settings-inner-nav-outlet">
        <Outlet />
      </div>
    </div>
  );
}
